import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'academyLink',
  standalone: false,
})
export class AcademyLinkPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string): string {
    const languageKey = this.translate.currentLang;
    return `https://www.agrolab.com/aloora-docs/${languageKey}/${value}`;
  }
}
